"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var Autocomplete_1 = __importDefault(require("atomicComponents/organisms/Autocomplete"));
var hooks_1 = require("atomicComponents/organisms/SortableHeader/hooks");
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var FooterMaker_1 = __importDefault(require("containers/TableMaker/FooterMaker"));
var HeaderMaker_1 = __importDefault(require("containers/TableMaker/HeaderMaker"));
var RowMaker_1 = __importDefault(require("containers/TableMaker/RowMaker"));
var SimplifyFormInput_1 = __importDefault(require("shared/components/Form/HoC/SimplifyFormInput"));
var general_1 = require("utils/general");
var populatedDerived_1 = require("utils/selectors/populatedDerived");
var single_1 = require("utils/selectors/single");
var perPlanTableConf_1 = __importDefault(require("./perPlanTableConf"));
var Header = (0, HeaderMaker_1.default)(perPlanTableConf_1.default);
var Row = (0, RowMaker_1.default)(perPlanTableConf_1.default);
var Footer = (0, FooterMaker_1.default)(perPlanTableConf_1.default);
var SimplifiedAutocomplete = (0, SimplifyFormInput_1.default)(Autocomplete_1.default);
var PerPlanOnchargeSettings = function (_a) {
    var _b, _c;
    var rechargedCompanyVendor = _a.rechargedCompanyVendor;
    // useFirestoreConnect(() => [
    //   { collection: 'recharged_vendor_plans', where: ['rechVendorId', '==', rechargedCompanyVendor?.rechVendorId] },
    // ]);
    var rechargerCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    var _d = __read((0, react_1.useState)((_c = (_b = rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.rechargesCurrency) !== null && _b !== void 0 ? _b : rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.baseCurrency) !== null && _c !== void 0 ? _c : 'AUD'), 2), currency = _d[0], setCurrency = _d[1];
    var selectRechargedVendorPlansForVendorWithSettings = (0, react_1.useMemo)(function () { var _a; return (0, populatedDerived_1.makeSelectRechargedVendorPlansForVendorWithSettings)((_a = rechargedCompanyVendor === null || rechargedCompanyVendor === void 0 ? void 0 : rechargedCompanyVendor.rechVendorId) !== null && _a !== void 0 ? _a : 'None', currency); }, [rechargedCompanyVendor === null || rechargedCompanyVendor === void 0 ? void 0 : rechargedCompanyVendor.rechVendorId, currency]);
    var rechargedVendorPlansForVendorWithSettings = (0, react_redux_1.useSelector)(selectRechargedVendorPlansForVendorWithSettings);
    var sortedRechargedVendorPlans = (0, hooks_1.useSortArray)(rechargedVendorPlansForVendorWithSettings, perPlanTableConf_1.default.extractors);
    if (!(0, react_redux_firebase_1.isLoaded)(sortedRechargedVendorPlans)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ width: 240 }, { children: (0, jsx_runtime_1.jsx)(SimplifiedAutocomplete, { options: (0, general_1.makeValueLabelArray)(['AUD', 'NZD']), label: "Select Currency", placeholder: "Select Currency", onChange: function (opt) { return (opt === null || opt === void 0 ? void 0 : opt.value) && setCurrency(opt === null || opt === void 0 ? void 0 : opt.value); }, noOptionsText: "Select Currency", value: { label: currency, value: currency }, btnProps: { className: 'highlightInput' } }) })), (0, jsx_runtime_1.jsxs)(Table_1.default, __assign({ maxWidth: 1200, px: 4, ml: -2 }, { children: [(0, jsx_runtime_1.jsx)(Header, { count: sortedRechargedVendorPlans.length, width: "100%" }), (0, jsx_runtime_1.jsx)(TableBody_1.default, __assign({ width: "100%" }, { children: sortedRechargedVendorPlans.map(function (item) { return (0, jsx_runtime_1.jsx)(Row, { item: item }, item.id); }) })), (0, jsx_runtime_1.jsx)(Footer, { items: rechargedVendorPlansForVendorWithSettings !== null && rechargedVendorPlansForVendorWithSettings !== void 0 ? rechargedVendorPlansForVendorWithSettings : [], width: "100%" })] }))] }));
};
exports.default = PerPlanOnchargeSettings;
